exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a[data-v-32319306]{cursor:pointer}.link-img[data-v-32319306]{padding-bottom:3px;width:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32319306","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/period-modules/braster-allowed.vue
// module id = 879
// module chunks = 0